const QUICK_RETURN_LOCK_KEY = "edu_game_quick_return_lock";

export function getQuickReturnUserId(): string | null {
  try {
    const userId = window.localStorage.getItem(QUICK_RETURN_LOCK_KEY)?.trim();
    return userId && userId.length <= 128 ? userId : null;
  } catch {
    return null;
  }
}

export function setQuickReturnUserId(userId: string) {
  try {
    window.localStorage.setItem(QUICK_RETURN_LOCK_KEY, userId);
  } catch {
    // Private browsing or device policy can disable local storage.
  }
}

export function clearQuickReturnUserId() {
  try {
    window.localStorage.removeItem(QUICK_RETURN_LOCK_KEY);
  } catch {
    // Private browsing or device policy can disable local storage.
  }
}
